import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocationProvider } from './components/AreaContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LocationProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </LocationProvider>

);

reportWebVitals();
